import endpoints from "../../lib/endpoints";
import getRequest, { getRequestNew } from "../../lib/fetchClient";
import { baseUrl } from "../../lib/util";
// import qs from "qs";
import { stringify } from "qs";

export const getCategories = async (signal, params, limit) => {
  const queryParams = {
    populate: {
      0: "image",
      1: "courses.thumbnail",
      2: "courses.brands",
    },
    pagination: {
      limit: limit || 5,
      withCount: true,
    },
  };

  if (params.showHome) {
    queryParams.filters = {
      show_on_home: {
        $eq: true,
      },
    };
  }

  // const querySting = qs.stringify(queryParams, { encodeValuesOnly: true });
  const querySting = stringify(queryParams, { encodeValuesOnly: true });

  try {
    return await getRequest(
      baseUrl + endpoints.categories + `?${querySting}&sort=showing_order:asc`,
      {
        signal,
        lang: params?.lang,
        next: { tags: ["categories"] },
      }
    );
  } catch (error) {
    console.log(error);
  }
};

export const getCategoriesNew = async (signal, params, limit) => {
  const queryParams = {
    pagination: {
      limit: limit || 5,
      withCount: true,
    },
  };

  if (params.showHome) {
    queryParams.filters = {
      show_on_home: {
        $eq: true,
      },
    };
  }

  // const querySting = qs.stringify(queryParams, { encodeValuesOnly: true });
  const querySting = stringify(queryParams, { encodeValuesOnly: true });

  try {
    return await getRequestNew(
      baseUrl + endpoints.categories + `?${querySting}&sort=showing_order:asc`,
      {
        signal,
        lang: params?.lang,
      },
      true,
      false
    );
  } catch (error) {
    console.log(error);
  }
};

export const getCategory = async (type, params) => {
  try {
    return await getRequest(baseUrl + endpoints.singleCategory + `/${type}`, {
      lang: params?.lang,
    });
  } catch (error) {
    console.log(error);
  }
};
